import jQuery from 'jquery';

Object.assign(window, { $: jQuery, jQuery });
